import { useGetCategoryListQuery } from '@/Module/Grade/Store/Query/CategoryListQuery';

export const useFindField = () => {
  const { data: Category = [] } = useGetCategoryListQuery();
  return Category.filter(item => item.categoryTypeId === 3).slice(1, 6);
};
